/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Addnewanimal3Inputs */

const en_newpatient_addnewanimal3 = /** @type {(inputs: Newpatient_Addnewanimal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a new pet`)
};

const fr_newpatient_addnewanimal3 = /** @type {(inputs: Newpatient_Addnewanimal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un autre animal`)
};

/**
* | output |
* | --- |
* | "Add a new pet" |
*
* @param {Newpatient_Addnewanimal3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_addnewanimal3 = /** @type {((inputs?: Newpatient_Addnewanimal3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Addnewanimal3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_addnewanimal3(inputs)
	return fr_newpatient_addnewanimal3(inputs)
});
export { newpatient_addnewanimal3 as "newPatient_addNewAnimal" }